import { render } from "./MaterialOrderView.vue?vue&type=template&id=78febb26&scoped=true"
import script from "./MaterialOrderView.vue?vue&type=script&lang=js"
export * from "./MaterialOrderView.vue?vue&type=script&lang=js"

import "./MaterialOrderView.vue?vue&type=style&index=0&id=78febb26&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78febb26"]])

export default __exports__